import calculated from "./calculated.png";
import matterPort from "./matterport-service.jpg";
import optimized from "./optimized.png";
import processMeasurment from "./prozess-aufmassservice.png";
import sized from "./sized.png";
import stamp from "./stamp.png";

export { calculated, matterPort, optimized, processMeasurment, sized, stamp };
